var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-json-pretty',{attrs:{"data":_vm.data,"show-line":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }